<script setup>
defineProps({
  payments: {
    type: Array,
    default: () => [],
  },
});

const formatCurrency = cents => {
  return `R$ ${(cents / 100).toFixed(2)}`;
};

const formatDate = dateStr => {
  if (!dateStr) return '-';
  return new Date(dateStr).toLocaleDateString('pt-BR');
};

const statusClass = status => {
  const classes = {
    confirmed: 'text-g-500',
    pending: 'text-y-600',
    failed: 'text-r-500',
    refunded: 'text-n-slate-11',
  };
  return classes[status] || '';
};
</script>

<template>
  <div v-if="payments.length">
    <!-- Desktop: table -->
    <div class="hidden sm:block overflow-x-auto">
      <table class="w-full text-sm">
        <thead>
          <tr class="border-b border-n-weak text-left text-n-slate-11">
            <th class="py-2 px-3 font-medium">
              {{ $t('BILLING_SETTINGS.INTERNAL.PAYMENTS.DATE') }}
            </th>
            <th class="py-2 px-3 font-medium">
              {{ $t('BILLING_SETTINGS.INTERNAL.PAYMENTS.AMOUNT') }}
            </th>
            <th class="py-2 px-3 font-medium">
              {{ $t('BILLING_SETTINGS.INTERNAL.PAYMENTS.METHOD') }}
            </th>
            <th class="py-2 px-3 font-medium">
              {{ $t('BILLING_SETTINGS.INTERNAL.PAYMENTS.STATUS') }}
            </th>
            <th class="py-2 px-3 font-medium">
              {{ $t('BILLING_SETTINGS.INTERNAL.PAYMENTS.DUE_DATE') }}
            </th>
          </tr>
        </thead>
        <tbody>
          <tr
            v-for="payment in payments"
            :key="payment.id"
            class="border-b border-n-weak"
          >
            <td class="py-2 px-3">
              {{ formatDate(payment.paid_at || payment.created_at) }}
            </td>
            <td class="py-2 px-3 font-medium">
              {{ formatCurrency(payment.amount_cents) }}
            </td>
            <td class="py-2 px-3 uppercase text-xs">
              {{ payment.payment_method }}
            </td>
            <td class="py-2 px-3">
              <span :class="statusClass(payment.status)" class="font-medium">
                {{ payment.status }}
              </span>
            </td>
            <td class="py-2 px-3">
              {{ formatDate(payment.due_date) }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <!-- Mobile: cards -->
    <div class="sm:hidden space-y-3 px-5">
      <div
        v-for="payment in payments"
        :key="payment.id"
        class="rounded-lg border border-n-weak p-3 space-y-2"
      >
        <div class="flex items-center justify-between">
          <span class="font-medium text-sm">
            {{ formatCurrency(payment.amount_cents) }}
          </span>
          <span
            :class="statusClass(payment.status)"
            class="font-medium text-xs"
          >
            {{ payment.status }}
          </span>
        </div>
        <div class="flex items-center justify-between text-xs text-n-slate-11">
          <span class="uppercase">{{ payment.payment_method }}</span>
          <span>
            {{ formatDate(payment.paid_at || payment.created_at) }}
          </span>
        </div>
      </div>
    </div>
  </div>
  <p v-else class="text-n-slate-11 text-sm px-5">
    {{ $t('BILLING_SETTINGS.INTERNAL.PAYMENTS.EMPTY') }}
  </p>
</template>
